module.exports = {
	"id": "OM",
	"name": "Oman",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.004083,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.006805,
			"10": 0.002722,
			"11": 0.008166,
			"12": 0.002722,
			"13": 0.002722,
			"14": 0.004083,
			"15": 0.001361,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.008166,
			"20": 0.004083,
			"21": 0.002722,
			"22": 0.008166,
			"23": 0.005444,
			"24": null,
			"25": 0.005444,
			"26": 0.005444,
			"27": 0.002722,
			"28": 0.005444,
			"29": 0.01361,
			"30": 0.006805,
			"31": 0.008166,
			"32": 0.004083,
			"33": 0.048996,
			"34": 0.009527,
			"35": 0.009527,
			"36": 0.006805,
			"37": 0.002722,
			"38": 0.021776,
			"39": 0.012249,
			"40": 0.006805,
			"41": 0.002722,
			"42": 0.01361,
			"43": 0.08166,
			"44": 0.021776,
			"45": 0.008166,
			"46": 0.012249,
			"47": 0.024498,
			"48": 0.016332,
			"49": 0.366109,
			"50": 0.024498,
			"51": 0.12249,
			"52": 0.097992,
			"53": 5.106472,
			"54": 1.380054,
			"55": 0.035386,
			"56": 0.006805,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": 0.001361,
			"5": 0.001361,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.002722,
			"11": 0.001361,
			"12": 0.005444,
			"13": null,
			"14": 0.001361,
			"15": null,
			"16": 0.004083,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.002722,
			"23": null,
			"24": null,
			"25": 0.001361,
			"26": null,
			"27": null,
			"28": 0.002722,
			"29": 0.001361,
			"30": 0.005444,
			"31": null,
			"32": 0.005444,
			"33": 0.002722,
			"34": 0.008166,
			"35": 0.002722,
			"36": 0.002722,
			"37": 0.002722,
			"38": 0.005444,
			"39": 0.004083,
			"40": 0.009527,
			"41": 0.002722,
			"42": 0.004083,
			"43": 0.023137,
			"44": 0.016332,
			"45": 0.014971,
			"46": 0.01361,
			"47": 0.092548,
			"48": 0.092548,
			"49": 0.771687,
			"50": 0.050357,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.005444
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.002722,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.004083,
			"37": 0.020415,
			"38": 0.004083,
			"39": 0.001361,
			"40": 0.107519,
			"41": 0.020415,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.002722
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.004083,
			"6": 0.004083,
			"7": 0.006805,
			"8": 0.050357,
			"9": 0.073494,
			"10": 0.215038,
			"3.1": null,
			"3.2": null,
			"5.1": 0.01361,
			"6.1": 0.021776,
			"7.1": 0.001361,
			"9.1": 0.352499
		},
		"ios_saf": {
			"8": 0,
			"10": 2.07310361366,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.055867743547,
			"8.1-8.4": 0.103213288926,
			"9.0-9.2": 0.049239367194,
			"9.3": 0.751215986678
		},
		"android": {
			"3": 0,
			"4": 0.214571162791,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0268213953488,
			"4.1": 0.773988837209,
			"4.2-4.3": 1.93497209302,
			"4.4": 4.43702511628,
			"4.4.3-4.4.4": 4.47534139535
		},
		"ie": {
			"6": null,
			"7": 0.00272758358974,
			"8": 0.421411664615,
			"9": 0.237299772308,
			"10": 0.267303191795,
			"11": 1.73065178769,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0125125823512,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000347571731979
		},
		"edge": {
			"12": 0.035386,
			"13": 0.153793,
			"14": 0.200067
		},
		"ie_mob": {
			"10": 0.0255549295775,
			"11": 0.104045070423
		},
		"bb": {
			"7": 0.0108,
			"10": null
		},
		"samsung": {
			"0": 4.38912
		},
		"and_uc": {
			"0": 0.1296
		},
		"op_mini": {
			"0": 0.168579845917
		},
		"and_chr": {
			"0": 66.440366
		},
		"and_ff": {
			"0": 0.00864
		}
	},
	"total": 98.854475
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/OM.json
 ** module id = 616
 ** module chunks = 0
 **/